import { useEffect, useState } from "react";
import { SourceListItem } from "../../interfaces/SourceListItemObj";
import { listAllDocumentCoObjects, listDocumentCoObjects } from "../../../api/object/CoObjectGeneral";
import { DocumentPartTreeSelection } from "../DocumentPartTree";

interface SourceListPageHookProps {
  documentPartTreeSelection: DocumentPartTreeSelection;
  idPartRoot?: string;
}

export const useSourceListPage = (props: SourceListPageHookProps) => {
  const [documentSourceList, setDocumentSourceList] = useState<SourceListItem[]>([]);

  useEffect(() => {
    if (!props.documentPartTreeSelection) {
      listAllDocumentCoObjects(props.idPartRoot)
        .then((result) => addDbInDescriptionIfNeeded(result))
        .then((result) => setDocumentSourceList(result));
    } else {
      listDocumentCoObjects(props.documentPartTreeSelection.data.key)
        .then((result) => addDbInDescriptionIfNeeded(result))
        .then((result) => setDocumentSourceList(result));
    }
  }, []);

  const addDbInDescriptionIfNeeded = (sourceListItems: SourceListItem[]) => {
    const sourceListItemsWithMoreDbIds: SourceListItem[] = [];
    const firstElementFromDb = sourceListItems.find((item) => item.dbId && item.dbId !== "");
    let thereIsJustOneDb = true;
    thereIsJustOneDb = addDbInSourceItemDesc(
      sourceListItems,
      firstElementFromDb,
      thereIsJustOneDb,
      sourceListItemsWithMoreDbIds
    );
    if (thereIsJustOneDb) return sourceListItems;
    else return sourceListItemsWithMoreDbIds;
  };

  function addDbInSourceItemDesc(
    sourceListItems: SourceListItem[],
    firstElementFromDb: SourceListItem,
    thereIsJustOneDb: boolean,
    sourceListItemsWithMoreDbIds: SourceListItem[]
  ) {
    for (const item of sourceListItems) {
      if (
        isNotNullOrEmpty(item.dbId) &&
        firstElementFromDb &&
        isNotNullOrEmpty(firstElementFromDb.dbId) &&
        firstElementFromDb.dbId !== item.dbId
      )
        thereIsJustOneDb = false;
      sourceListItemsWithMoreDbIds.push({
        ...item,
        desc: formatDesc(item.dbId, item.desc, item.cod, item.descDb),
      });
    }
    return thereIsJustOneDb;
  }

  const isNotNullOrEmpty = (element: string) => {
    return element && element !== "";
  };

  const formatDesc = (dbId: string, desc: string, idForm: string, descDb: string) => {
    if (!descDb || descDb === "") descDb = dbId;
    if (!desc || desc === "") desc = idForm;
    if (dbId && descDb) return `${descDb} - ${desc}`;
    return desc;
  };

  return { documentSourceList };
};
